import { ComponentAction, ComponentMutation } from "../types";
import { Session } from "@/framework/types/Session";
import { addMinutesToDate } from "@/framework/utilities/addMinutesToDate";
import { isEmpty } from "@/framework/utilities/isEmpty";

export default {
  [ComponentAction.setNavigation]({ commit }: any, navigation: any) {
    commit(ComponentMutation.SET_NAVIGATION, navigation);
  },
  [ComponentAction.setNavigationUpdate]({ commit }: any, navigationUpdate: any) {
    // was missing before - deprecrated?
    commit(ComponentMutation.SET_NAVIGATION_UPDATE, navigationUpdate);
  },
  [ComponentAction.setAppMode]({ commit }: any, appMode: any) {
    commit(ComponentMutation.SET_APP_MODE, appMode);
  },
  [ComponentAction.setIsLoading]({ commit }: any, isLoading: any) {
    commit(ComponentMutation.SET_IS_LOADING, isLoading);
  },
  [ComponentAction.setIsSaving]({ commit }: any, isSaving: any) {
    commit(ComponentMutation.SET_IS_SAVING, isSaving);
  },
  [ComponentAction.setIsEnableKtznLang]({ commit }: any, isEnableKtznLang: boolean) {
    commit(ComponentMutation.SET_IS_ENABLE_KTZN_LANG, isEnableKtznLang);
  },
  [ComponentAction.setBottomNavigation]({ commit }: any, bottomNavigation: any) {
    commit(ComponentMutation.SET_BOTTOM_NAVIGATION, bottomNavigation);
  },
  [ComponentAction.setIsWeChat]({ commit }: any, isWeChat: boolean) {
    commit(ComponentMutation.SET_IS_WECHAT, isWeChat);
  },
  [ComponentAction.closePrivacyPolicyFooter]({ commit }: any) {
    commit(ComponentMutation.SET_CLOSE_PRIVACY_POLICY_FOOTER, true);
  },
  [ComponentAction.setReConnectingNow]({ commit }: any, reConnectingNow: boolean) {
    commit(ComponentMutation.SET_IS_RE_CONNECTINT_NOW, reConnectingNow);
  },
  [ComponentAction.createSession]({ commit, getters }: any, sessionTimeout: number) {
    let storedSession = getters.session;
    let newSession: Session;
    if (isEmpty(storedSession)) {
      newSession = {
        timeout: sessionTimeout,
        firstAccess: new Date(),
        expirationDate: addMinutesToDate(new Date(), sessionTimeout),
      };
    } else {
      newSession = {
        timeout: sessionTimeout,
        firstAccess: storedSession.firstAccess,
        expirationDate: addMinutesToDate(storedSession.firstAccess, sessionTimeout),
      };
    }
    commit(ComponentMutation.SET_SESSION, newSession);
  },
  [ComponentAction.setSession]({ commit }: any, session: Session) {
    commit(ComponentMutation.SET_SESSION, session);
  },
  [ComponentAction.setCheckNotificationPermission]({ commit }: any, data: boolean) {
    commit(ComponentMutation.SET_CHECK_NOTIFICATION_PERMISSION, data);
  },
  [ComponentAction.guestHideHomeIcon]({ commit }: any, data: boolean) {
    commit(ComponentMutation.GUEST_HIDE_HOME_ICON, data);
  },
};
